import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faLinkedinIn, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import c2cLogo from '../assets/images/c2c-logo-name.png';

const Footer = () => {
  const handleLogoClick = () => {
    window.setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  const footerLinks = {
    products: [
      { name: 'C2C Business', href: '#products' },
      { name: 'C2C Softphone', href: '/softphone' },
      { name: 'C2C Appliance', href: '#products' },
      { name: 'C2C AI Agent', href: '#products' }
    ],
    platform: [
      { name: 'Features', href: '/features' },
      { name: 'Pricing', href: 'https://www.contexttocall.com/subscription' },
      { name: 'User Guide', href: '/user-guide' },
      { name: 'Sign In', href: 'https://app.contexttocall.com/account/sign-in' }
    ],
    company: [
      { name: 'Book a Demo', href: 'https://outlook.office365.com/book/RequestDemo@vgroupinc.com/' },
      { name: 'Terms & Conditions', href: '/terms' },
      { name: 'Privacy Policy', href: 'https://www.vgroupinc.com/privacy-policy' }
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" onClick={handleLogoClick}>
              <img src={c2cLogo} alt="Context to Call" className="logo-image" />
              <span className="logo-text">Context to Call</span>
            </Link>
            <p>
              A very simple yet effective platform to add Call, SMS, or Email buttons to your website — 
              visitors connect with one simple touch.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/C2CBusinessSolutions/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://twitter.com/contexttocall" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a href="https://www.linkedin.com/showcase/click-2-call/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a href="https://www.youtube.com/@ContexttoCall" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>
          
          <div className="footer-column">
            <h4>Products</h4>
            <ul>
              {footerLinks.products.map((link, index) => (
                <li key={index}>
                  {link.href.startsWith('/') ? (
                    <Link to={link.href}>{link.name}</Link>
                  ) : (
                    <a href={link.href}>{link.name}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Platform</h4>
            <ul>
              {footerLinks.platform.map((link, index) => (
                <li key={index}>
                  {link.href.startsWith('http') ? (
                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                      {link.name}
                    </a>
                  ) : (
                    <Link to={link.href}>{link.name}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  {link.href.startsWith('/') ? (
                    <Link to={link.href}>{link.name}</Link>
                  ) : (
                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>Copyright © 2026 Context to Call. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/terms">Terms</Link>
            <a href="https://www.vgroupinc.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy</a>
            <a href="#contact">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
